import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { setupInterceptors } from './services/httpInterceptors';
import VueAnalytics from 'vue-analytics';

import "./assets/sass/main.scss";
import { library } from '@fortawesome/fontawesome-svg-core'
import {faPlus, faMinus,faSearch, faArrowAltCircleUp, faSpinner, faAngleDoubleDown ,faAngleDoubleUp, 
  faTimes, faCompress, faPrint, faCaretRight, faCaretDown} from '@fortawesome/free-solid-svg-icons'
import { faFacebook,faLinkedin,faTwitter } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueSimpleAlert from "vue-simple-alert";

Vue.use(VueSimpleAlert);

library.add(faPlus, faMinus,faSearch,faFacebook,faLinkedin,faTwitter, 
  faArrowAltCircleUp, faSpinner,faAngleDoubleDown,faAngleDoubleUp, faTimes, 
    faCompress, faPrint, faCaretRight, faCaretDown);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.config.productionTip = false

Vue.use(VueAnalytics, {
  id: 'UA-2086824-9'
});

new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    setupInterceptors(store);
  }
}).$mount('#app')
